import React, { useEffect, useState } from 'react';

import FieldRadio from '../fields/fieldRadio/FieldRadio';
import RawHtml from '../rawHtml/RawHtml';
import ChannelImage from '../../containers/channelUtils/ChannelImage';
import Button from '../button/Button';
import cx from 'classnames';

export default function CheckoutMethodField({
  methods,
  onMethodChange,
  input,
  meta: { touched, error },
}) {
  const [expanded, setExpanded] = useState(false);
  const displayError = touched && error;

  const selectedMethod = input.value && methods.find((it) => it.code === input.value);

  useEffect(() => {
    if (selectedMethod) {
      onMethodChange(selectedMethod);
    }
  }, [selectedMethod]);

  return (
    <div className="checkout__payment">
      <div className="checkout__payment-method-list">
        {methods.map((method, idx) => (
          <div
            key={method.code}
            className={cx(
              'checkout__payment-method',
              !expanded && idx >= 2 && 'checkout__payment-method--hidden'
            )}
          >
            <FieldRadio
              className="field-radio--payment"
              input={{
                checked: input.value === method.code,
                onChange: () => input.onChange(method.code),
              }}
            >
              <span className="checkout__payment-image">
                {method.image ? <ChannelImage src={method.image} alt={method.name} /> : method.name}
              </span>
            </FieldRadio>
          </div>
        ))}

        <React.Fragment>
          {methods.length > 2 && (
            <Button
              type="button"
              onClick={() => setExpanded(!expanded)}
              disabled={methods.indexOf(selectedMethod) > 1}
            >
              {expanded ? 'Show Less' : 'Show More'}
            </Button>
          )}
        </React.Fragment>
      </div>

      {selectedMethod && selectedMethod.instructions && (
        <RawHtml className="checkout__payment-annotation" content={selectedMethod.instructions} />
      )}

      {displayError && <div className="field-radio__error-message">{error}</div>}
    </div>
  );
}



// WEBPACK FOOTER //
// ./components/checkout/CheckoutMethodField.js